import React, { forwardRef, ComponentProps } from "react";
import { CpBadgeVariants } from "./cp-badge-variants/cp-badge-variant";
import { CpBadgeProps } from "./cp-badge";
import { tw, always } from "src/utils";
import { CpBadgeContent } from "./cp-badge-variants/cp-badge-content";

type CpBadgeToggleProps = {
  active: boolean;
} & Omit<CpBadgeProps, "intent"> &
  ComponentProps<"button">;

export const CpBadgeToggle = forwardRef<HTMLButtonElement, CpBadgeToggleProps>(
  (props, ref) => {
    const {
      active = false,
      children,
      className,
      disabled,
      iconLeft,
      iconOnly,
      iconRight,
      size = "md",
      ...rest
    } = props;
    return (
      <button
        ref={ref}
        className={always(
          tw(
            CpBadgeVariants({
              active: active,
              button: true,
              disabled: disabled,
              iconOnly: !!iconOnly,
              intent: "base",
              size,
            }),
          ),
          className,
        )}
        disabled={disabled}
        {...rest}
      >
        <CpBadgeContent
          iconLeft={iconLeft}
          iconOnly={iconOnly}
          iconRight={iconRight}
          size={size}
        >
          {children}
        </CpBadgeContent>
      </button>
    );
  },
);
